import { RefObject, useEffect, useRef, useState } from 'react';

// Breadcrumbs sit above the grid, so their height must leave its calc.
export const useBreadcrumbsHeight = (): {
  breadcrumbsRef: RefObject<HTMLDivElement | null>;
  breadcrumbsHeight: number;
} => {
  const breadcrumbsRef = useRef<HTMLDivElement>(null);
  const [breadcrumbsHeight, setBreadcrumbsHeight] = useState<number>(0);

  useEffect(() => {
    if (!breadcrumbsRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      setBreadcrumbsHeight(breadcrumbsRef.current?.clientHeight ?? 0);
    });
    resizeObserver.observe(breadcrumbsRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  return { breadcrumbsRef, breadcrumbsHeight };
};
